import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useRef, useState, useEffect, useMemo, useCallback, useContext } from 'react';
import uniqueId from 'lodash/uniqueId';
import cn from 'classnames';
import ListHeader from '../../../List/ListHeader';
import CheckIcon from '../../../Icons/24x24/Check';
import { IconSize } from '../../../Icons/IconWrap';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { PopperDropdownManager } from '../../PopperDropdownLayout';
import { getSelectedItemByValue, findItemByValue } from '../../helpers';
import StandardDropdownMenu from '../StandardDropdown/StandardDropdownMenu';
import { DropdownStateContext } from '../../DropdownStateManager';
import s from './SelectionListItemDropdown.scss';
const ListItemDropdown = ({ items, renderToggle, selectedValue, className, menuClassName, menuLabel, menuRef, highlightActive = true, isInPopup, usePortal, forceTheme = ThemeOptions.LIGHT, onSelect })=>{
    const { setMenuRef } = useContext(DropdownStateContext);
    const [selectedItem, setSelectedItem] = useState(findItemByValue(selectedValue, items));
    const { current: dropdownId } = useRef(uniqueId('dropdown'));
    const dropdownItems = useMemo(()=>items.map((item)=>_object_spread_props(_object_spread({}, item), {
                suffix: highlightActive && (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) === item.value ? /*#__PURE__*/ React.createElement(CheckIcon, {
                    size: IconSize.MEDIUM,
                    className: s['check-icon'],
                    disableDefaultColors: true
                }) : undefined
            })), [
        items,
        highlightActive,
        selectedItem
    ]);
    const onMenuSelect = useCallback((value, label)=>{
        const selected = getSelectedItemByValue(value, items);
        if (selected === null || selected === void 0 ? void 0 : selected.disabled) {
            return;
        }
        setSelectedItem(selected);
        onSelect && onSelect(value, label);
    }, [
        items,
        onSelect
    ]);
    // Update selected state if it's undefined and `selectedValue` prop changes
    useEffect(()=>{
        if (selectedValue !== undefined) {
            if (!selectedItem) {
                setSelectedItem(findItemByValue(selectedValue, items));
            } else {
                // verify that selected item still exists
                if (findItemByValue(selectedItem.value, items)) {
                    setSelectedItem(findItemByValue(selectedValue, items));
                }
            }
        }
    }, [
        selectedItem,
        selectedValue,
        items
    ]);
    const menuRefHandler = (node)=>{
        // Set reference on dropdown state - this is required for dropdown to work properly
        setMenuRef(node);
        // Set reference on external prop - useful if we need a ref to the menu outside this component
        menuRef && menuRef(node);
    };
    return /*#__PURE__*/ React.createElement(PopperDropdownManager, {
        isInPopup: isInPopup
    }, renderToggle(dropdownId, selectedItem), /*#__PURE__*/ React.createElement(StandardDropdownMenu, {
        id: dropdownId,
        role: "listbox",
        menuInnerRef: menuRefHandler,
        menuLabel: menuLabel ? /*#__PURE__*/ React.createElement(ThemeOverride, {
            theme: ThemeOptions.LIGHT,
            className: s['list-header']
        }, /*#__PURE__*/ React.createElement(ListHeader, {
            withDivider: true
        }, menuLabel)) : undefined,
        menuLabelClassName: s['menu-label'],
        items: dropdownItems,
        itemClassName: s['dropdown-item'],
        menuClassName: cn(s['menu'], menuClassName),
        className: className,
        withHoverEffect: false,
        withMenuPaddings: false,
        hideCheckIcon: true,
        onSelect: onMenuSelect,
        usePortal: usePortal
    }));
};
ListItemDropdown.displayName = 'ListItemDropdown';
export default ListItemDropdown;

//# sourceMappingURL=SelectionListItemDropdown.js.map